import firebase from "firebase/app";
import "firebase/auth";

import Vue from "vue"
import Router from "vue-router"

import {store} from "@/plugins/store.js"

// store.getters.isLoggedIn
// store.state.currentUser


import tinkHome from "@/views/tinkHome.vue"

// import tinkTos from "@/views/tinkTos.vue"
// import tinkPrivacy from "@/views/tinkPrivacy.vue"
// import tinkAbout from "@/views/tinkAbout.vue"

// import tinkUser from "@/views/tinkUser.vue"
// import tinkDevice from "@/views/tinkDevice.vue"
// import tinkDeviceBySerial from "@/views/tinkDeviceBySerial.vue"
// import tinkSensor from "@/views/tinkSensor.vue"

// import tinkChart from "@/views/tinkChart.vue"

Vue.use(Router)

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
      {
          path: "/",
          name: "tinkHome",
          component: tinkHome,
          props: (route) =>({
              now: (route.query.now)? route.query.now: "",
          }),

          meta: {
            title: process.env.VUE_APP_DEV_TITLE + "tinkable 데이터 서비스에 오신 것을 환영합니다.",
          }
      },
      {
          path: "/about",
          name: "tinkAbout",
          component: () => import(/* webpackChunkName: "tinkAbout" */ "@/views/tinkAbout.vue"),
          meta: {
              // protected: true,
              title: "tinkable 소개"
          }
      },
      {
          path: "/iotKit",
          name: "tinkAboutKit",
          component: () => import(/* webpackChunkName: "tinkAbout" */ "@/views/tinkAboutKit.vue"),
          meta: {
              // protected: true,
              title: "tinkable IoT 키트 소개"
          }
      },
      {
          path: "/coreProgram",
          name: "tinkAboutCore",
          component: () => import(/* webpackChunkName: "tinkAbout" */ "@/views/tinkAboutCore.vue"),
          meta: {
              // protected: true,
              title: "tinkable Core 프로그램 소개"
          }
      },
      {
          path: "/dataService",
          name: "tinkAboutData",
          component: () => import(/* webpackChunkName: "tinkAbout" */ "@/views/tinkAboutData.vue"),
          meta: {
              // protected: true,
              title: "tinkable Data 서비스 소개"
          }
      },
      {
          path: "/tos",
          name: "tinkTos",
          component: () => import(/* webpackChunkName: "tinkTos" */ "@/views/tinkTos.vue"),
          meta: {
              title: "tinkable 데이터 서비스: 서비스 이용 약관"
          }
      },
      {
          path: "/privacy",
          name: "tinkPrivacy",
          component: ()=> import(/* webpackChunkName: "tinkPrivacy" */ "@/views/tinkPrivacy.vue"),
          meta: {
              // protected: true,
              title: "tinkable 데이터 서비스: 개인정보 보호 정책"
          }
      },
      {
        path: "/u/:uid",
        name: "tinkUser",
        component: () => import(/* webpackChunkName: "tinkUser" */"@/views/tinkUser.vue"),
        props: (route) =>({
            uid: route.params.uid,
            folder: "@root",
            action: (route.query.action)? route.query.action : "",
            mode: (route.query.mode)? route.query.mode: "list",
            marker: (route.query.marker)? route.query.marker: "",
        }),
        meta: {
          title: "tinkable 데이터: 기기 목록"
        }
      },
      {
        path: "/_admin",
        name: "tinkAdmin",
        component: () => import(/* webpackChunkName: "tinkAdmin" */"@/views/tinkAdmin.vue"),
        beforeEnter: (to, from, next) => {
          if(store.state.currentUser && store.state.currentUser.email == "data.tinkable@gmail.com") {
            next();
          }
          else {
            next({ path: '/'});
          }
        },
        props: (route) =>({
            mode: (route.query.mode)? route.query.mode: "serial",
        }),
        meta: {
          title: "tinkable 데이터: 관리자"
        }
      },
      {
        path: "/u/:uid/:folder",
        name: "tinkUserFolder",
        component: () => import(/* webpackChunkName: "tinkUser" */"@/views/tinkUser.vue"),
        props: (route) =>({
            uid: route.params.uid,
            folder: route.params.folder,
            action: (route.query.action)? route.query.action : "",
            mode: (route.query.mode)? route.query.mode: "list",
            marker: (route.query.marker)? route.query.marker: "",
        }),
        meta: {
          title: "tinkable 데이터: 기기 목록"
        }
      },
      {
        path: "/dbs/:serial",
        name: "tinkDeviceBySerial",
        component: () => import(/* webpackChunkName: "tinkDeviceBySerial" */ "@/views/tinkDeviceBySerial.vue"),
        props: (route) =>({
          serial: route.params.serial
        }),
        meta: {
          title: "tinkable 데이터: 기기"
        }
      },
      {
        path: "/d/:did",
        name: "tinkDevice",
        component: () => import(/* webpackChunkName: "tinkDevice" */ "@/views/tinkDevice.vue"),
        props: (route) =>({
          did: route.params.did,
          action: (route.query.action)? route.query.action : "",
          mode: (route.query.mode)? route.query.mode: "intro",
        }),
        meta: {
          title: "tinkable 데이터: 기기"
        }
      },
      {
        path: "/s/:sid",
        name: "tinkSensor",
        component: () => import(/* webpackChunkName: "tinkSensor" */ "@/views/tinkSensor.vue"),
        props: (route) =>({
          sid: route.params.sid,
          action: (route.query.action)? route.query.action : "",
          mode: (route.query.mode)? route.query.mode: "grid",
          pFromId: (route.query.pFromId)? route.query.pFromId*1: null,
          pToId: (route.query.pToId)? route.query.pToId*1: null,
          pFromBook: (route.query.pFromBook)? route.query.pFromBook*1: null,
          pToBook: (route.query.pToBook)? route.query.pToBook*1: null,
          pFromDate: (route.query.pFromDate)? route.query.pFromDate: "",
          pToDate: (route.query.pToDate)? route.query.pToDate: "",
          pFromDateEpoch: (route.query.pFromDateEpoch)? route.query.pFromDateEpoch*1: null,
          pToDateEpoch: (route.query.pToDateEpoch)? route.query.pToDateEpoch*1: null,
          pPresentation: (route.query.pPresentation&&(route.query.pPresentation==='1'))? true:false,
          pEditControl: (route.query.pEditControl&&(route.query.pEditControl==='0'))? false:true,
          pScopeControl: (route.query.pScopeControl&&(route.query.pScopeControl==='0'))? false:true,
          pSubControl: (route.query.pSubControl&&(route.query.pSubControl==='0'))? false:true,
          pPageControl: (route.query.pPageControl&&(route.query.pPageControl==='0'))? false:true,
          pHeight:(route.query.pHeight)?route.query.pHeight: "",
          pOverflowY:(route.query.pOverflowY)? route.query.pOverflowY:"",
          pGroupBy:(route.query.pGroupBy)? route.query.pGroupBy:"",
          pColumns:(route.query.pColumns)? route.query.pColumns:"",
          pPerPage:(route.query.pPerPage)? route.query.pPerPage*1:null,
          pCurrent:(route.query.pCurrent)? route.query.pCurrent*1:null,
          pXMin:(route.query.pXMin)? route.query.pXMin*1:null,
          pXMax:(route.query.pXMax)? route.query.pXMax*1:null,
          pSortBy:(route.query.pSortBy)? route.query.pSortBy:"",
          pSortDesc:(route.query.pSortDesc&&(route.query.pSortDesc==='0'))? false:true,
          pChartOptions:(route.query.pChartOptions)? route.query.pChartOptions:""
        }),
        meta: {
          title: "tinkable 데이터: 센서"
        }
      },
      {
          path: "*",
          name: "others",
          component: tinkHome,
          meta: {
            title: "tinkable 데이터 서비스에 오신 것을 환영합니다."
          }
      },
    ],
});
